import Storage from '@/services/storage.js';
const storage = new Storage();
export default function currentUser() {
  return storage.getSavedState('currentUser');
}